export default {"src":"/_next/static/media/Logo_Xylo_texte_circulaire.f83b28d9.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};